import React from "react";
import { Location } from "@navigation";
import { CustomerContractProfile } from "../CustomerContractProfile/CustomerContractProfile";

interface Params {
  id: string;
}

export class CustomerContractProfileLocation extends Location<Params> {
  constructor(id: string) {
    super({ id });
  }

  render() {
    return <CustomerContractProfile id={this.params.id} />;
  }

  toURI(): string {
    return `/customer_contracts/${this.params.id}`;
  }
}
